import React from 'react'
import { Button, Dropdown, makeStyles, Option, tokens } from '@fluentui/react-components'
import { ArrowExport20Regular } from '@fluentui/react-icons'
import { t } from 'i18next'
import { Card } from '../../common/card/Card'
import { exportDemandActionPlansToExcel, exportLawListToExcel } from '../../../helpers/excelHelper'
import { ActionPlan, DemandAnalysis } from '../../../api/schemas/schema'
import { ModalActionPlanReport } from './ModalActionPlanReport'
import { PhoneHeader } from '../../common/header/PhoneHeader'

const useStyles = makeStyles({
   processDropdown: {
      '@media screen and (max-width: 1007px)': {
         width: '100%',
      },
   },
   content: {
      display: 'flex',
      gap: tokens.spacingHorizontalXL,
      '@media screen and (max-width: 1007px)': {
         marginBottom: tokens.spacingVerticalM,
         flexDirection: 'column',
      },
   },
   noneInPhone: {
      '@media screen and (max-width: 1007px)': {
         display: 'none',
      },
   },
   buttonWrapper: {
      display: 'flex',
      gap: tokens.spacingHorizontalL,
   },
})

type ActionPlanHeaderProps = {
   analysis: DemandAnalysis
   filteredActionPlans: ActionPlan[]
   setProcess: (process: string) => void
   processes: string[]
   selectedProcess: string
   disabled?: boolean
}

export const ActionPlanHeader = ({ analysis, filteredActionPlans, setProcess, processes, selectedProcess, disabled }: ActionPlanHeaderProps) => {
   const classes = useStyles()
   return (
      <>
         <PhoneHeader title={t('ActionPlan')} action={<ModalActionPlanReport questions={analysis.questions} />} />
         <Card
            title={t('ActionPlan')}
            transparentInPhone
            contentClassName={classes.content}
            action={
               <div className={classes.buttonWrapper}>
                  <Button className={classes.noneInPhone} icon={<ArrowExport20Regular />} onClick={() => exportLawListToExcel(analysis)} disabled={disabled}>
                     {t('ExportLawlistToExcel')}
                  </Button>
                  <ModalActionPlanReport questions={analysis.questions} disabled={disabled} />
               </div>
            }
         >
            <Dropdown
               className={classes.processDropdown}
               value={selectedProcess}
               selectedOptions={[selectedProcess]}
               onOptionSelect={(e, data) => {
                  setProcess(data.optionValue)
               }}
               disabled={disabled}
            >
               {processes.map((x) => {
                  return <Option key={x}>{x}</Option>
               })}
            </Dropdown>
            <Button
               className={classes.noneInPhone}
               icon={<ArrowExport20Regular />}
               onClick={() => exportDemandActionPlansToExcel(analysis, filteredActionPlans)}
               disabled={disabled}
            >
               {t('ExportToExcel')}
            </Button>
         </Card>
      </>
   )
}
